import { Grid } from '@material-ui/core';
import { useScrollButtonState } from '@ncr-retail/hooks';
import React from 'react';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { CartPaymentData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import Pagination from 'src/pagination/pagination';
import { getRowsClassName } from './cashback-helper';
import { styles } from './thank-you-modal-styles';

export const getChangeTenderName = (payment: CartPaymentData) => {
  return payment?.epsData ? `Cashback ${payment.tenderName}` : 'Change Due';
};
export const CashBackList = (props): JSX.Element => {
  const classes = styles();
  const { payments } = props;
  const changePayments: CartPaymentData[] = payments.filter(
    tender => tender.change > 0 || tender.cashBackAmount > 0,
  );

  const [
    { currentPage, lastPage, onPageChanged, navScrollUpEnabled, navScrollDownEnabled },
    scrollRef,
  ] = useScrollButtonState();
  return (
    <Grid container className='cashBackList'>
      <Grid container justifyContent='center' className='fullWidth'>
        <Grid
          container
          ref={scrollRef}
          className={`${getRowsClassName(changePayments)} 
          ${classes.tenderWindow} verticalScroll`}
          data-testid='tenderWindow'
        >
          {changePayments.map(tender => {
            return (
              <Grid
                container
                key={tender.sequenceNumber}
                className={`${classes.message} ${classes.noWrap} ${classes.tenderLine}`}
              >
                <Grid item className={`${classes.message} ${classes.noWrap} ${classes.tenderName}`}>
                  {getChangeTenderName(tender)}
                </Grid>
                <Grid item key={tender.sequenceNumber}>
                  {convertCurrency(tender.cashBackAmount || tender.change || 0)}
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Grid container justifyContent='center'>
        <Pagination
          currentPage={currentPage}
          totalPages={lastPage}
          updateCurrentPageHandler={onPageChanged}
          displayText={false}
          testIdPrefix={'cashback-list'}
          canScrollUp={navScrollUpEnabled}
          canScrollDown={navScrollDownEnabled}
        />
      </Grid>
    </Grid>
  );
};
